 document.addEventListener('DOMContentLoaded', function () {

  const videoContainers = document.querySelectorAll('.video_slider');
  
  videoContainers.forEach(container => {
    const video = container.querySelector('video');
    const playIcon = container.querySelector('.play-icon');
    
    if (!video || !playIcon) return;
    

    playIcon.style.display = 'block';
    

    const togglePlayPause = (e) => {
      e.preventDefault();
      e.stopPropagation();
      
      if (video.paused) {
        video.play();
        playIcon.style.display = 'none';
      } else {
        video.pause();
        playIcon.style.display = 'block';
      }
    };
    

    video.addEventListener('click', togglePlayPause);
    playIcon.addEventListener('click', togglePlayPause);
    

    video.addEventListener('ended', () => {
      playIcon.style.display = 'block';
    });
    
  
    video.addEventListener('play', () => {
      videoContainers.forEach(otherContainer => {
        const otherVideo = otherContainer.querySelector('video');
        const otherIcon = otherContainer.querySelector('.play-icon');
        
        if (otherVideo && otherVideo !== video && !otherVideo.paused) {
          otherVideo.pause();
          if (otherIcon) otherIcon.style.display = 'block';
        }
      });
    });
  });




 });